<template>
  <div class="col-12 mx-auto overflow-hidden">
    <!-- <a href='/#/Termin' style='color: red margin-bottom: 4rem'>Testlink</a> -->
    <h1 class="title">kostenlose Maschinenbewertung</h1>
    <div class="col-12 mx-auto border-box">
      <div class="flex stage-container mb3 small-border-radius">
        <div class="formstage bgcolor1">
          <p class="formstage-text passed">1. <span>Ihre Branche</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">2. <span>Ihre Maschine</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">3. <span>Anschaffung</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">4. <span>Ihre Kontaktdaten</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">5. <span>Echtzeitbewertung</span></p>
        </div>
      </div>
      <div class="container">
        <div class="text-box">
          <p>
            Um die Bewertung vorzunehmen, benötigen wir einige Angaben von Ihnen.
            In der Regel erhalten Sie im Anschluss sofort den realistischen
            Zeitwert Ihrer Produktionsmaschine.
          </p>
          <br />
          <p>Bitte wählen Sie die Branche Ihrer Maschine</p>
        </div>
        <div class="row flex material-box">
          <div class="col">
            <submit-button-branche
              name="Metall"
              img="metall"
              value="metall"
              event_name="pre_submit_step_0-metall"
            />
          </div>
          <div class="col">
            <submit-button-branche
              name="Holz"
              img="holz"
              event_name="pre_submit_step_0-holz"
            />
          </div>
          <div class="col">
            <submit-button-branche
              name="Druck"
              img="druck"
              event_name="pre_submit_step_0-druck"
            />
          </div>
        </div>
        <div class="row flex material-box">
          <div class="col">
            <submit-button-branche
              name="Kunststoff"
              img="kunststoff"
              event_name="pre_submit_step_0-kunststoff"
            />
          </div>
          <div class="col">
            <submit-button-branche
              name="Bau"
              img="bau"
              event_name="pre_submit_step_0-bau"
            />
          </div>
          <div class="col">
            <submit-button-branche
              name="Andere Branche"
              img="andere"
              event_name="pre_submit_step_0-andere"
            />
          </div>
        </div>
      </div>
      <div class="mb4"></div>
    </div>
    <cta-support-element />
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import SubmitButtonBranche from "./SubmitButton-Branche.vue";
import CTASupportElement from "./CTASupportElement.vue";
import axios from "axios";

export default {
  name: "OnboardingStep00",
  props: {
    name: String,
    event_name: String,
    button_style: String,
  },
  data() {
    return {
      notfilled: false,
      debug: false,
      placeholder: "Branche",
      windowWidth: "",
      isValid: false,
    };
  },
  created() {

    EventBus.$on("submit_step_0", () => {
      // Kein payload!
      this.log(this);
      this.log("OnboardingStep00 Event received: submit_step_0");
    });

    EventBus.$on("machinebranche_selected", (payload) => {
      this.log("OnboardingStep00 Event received: machinebranche_selected");
      this.log("OnboardingStep00 Event received: pre_submit_step_0");
      this.machinebranche_input_text = payload.input;

      if (this.machinebranche_input_text != "") {
        // Axios machen...
        let createURL =
          "https://enquiry.leaseback.de/onboarding/proof/machine-branche";

        if (window.location.host == "onboarding.leaseback.de") {
          createURL =
            "https://enquiry.leaseback.de/onboarding/proof/machine-branche";
        }
        let currentObj = this;
        axios
          .post(createURL, {
            machinebranche: currentObj.machinebranche_input_text,
          })
          .then(function(response) {
            if (response.data.isValid == true) {
              currentObj.isValid = true;
            } else {
              currentObj.notfilled = true;
              currentObj.isValid = false;
            }
          })
          .catch(function(error) {
            currentObj.log("catch Function of AJAX-Called... error()");
            currentObj.log(error);
            currentObj.apiResponse = error;
          });
      }
    });

    EventBus.$on("pre_submit_step_0-metall", () => {
      EventBus.$emit("submit_step_0", {
        opportunities_branche: "Metall",
      });
    });
    EventBus.$on("pre_submit_step_0-holz", () => {
      EventBus.$emit("submit_step_0", {
        opportunities_branche: "Holz",
      });
    });
    EventBus.$on("pre_submit_step_0-druck", () => {
      EventBus.$emit("submit_step_0", {
        opportunities_branche: "Druck",
      });
    });
    EventBus.$on("pre_submit_step_0-kunststoff", () => {
      EventBus.$emit("submit_step_0", {
        opportunities_branche: "Kunststoff",
      });
    });
    EventBus.$on("pre_submit_step_0-andere", () => {
      EventBus.$emit("submit_step_0", {
        opportunities_branche: "Andere",
      });
    });
    EventBus.$on("pre_submit_step_0-bau", () => {
      EventBus.$emit("submit_step_0", {
        opportunities_branche: "Bau",
      });
    });
  },
  components: {
    "submit-button-branche": SubmitButtonBranche,
    "cta-support-element": CTASupportElement,
  },
  methods: {
    submit: function() {
      this.log(
        "OnboardingStep00.vue: Emitting Event using Submit: " + this.event_name
      );
      EventBus.$emit("" + this.event_name);
    },
    log: function(obj) {
      if (this.debug) {
        this.log(obj);
      }
    },
  },
};
</script>

<style scoped>

.col {
  width: 100%;
  margin-bottom: 1%;
}

.col:not(:last-child){
  margin-right: 1.5%;
}

@media (max-width: 1060px) {
  .material-box {
    flex-direction: column;
  }
  .material-box .col {
    width: 100%;
  }
}
</style>
